// extracted by mini-css-extract-plugin
export default {"recipeFooter":"style-module--recipeFooter--528f1"};